import { render, staticRenderFns } from "./modalAddSponsorAttributes.vue?vue&type=template&id=5c37924c&"
import script from "./modalAddSponsorAttributes.vue?vue&type=script&lang=js&"
export * from "./modalAddSponsorAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports